import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { translate } from 'react-i18next';
import Navigation from '../components/Navigation';
import FactTable from '../components/FactTable';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import { Link } from 'react-router-dom';

import axios from 'axios';
import {
    Panel,
    Col,
    Row,
    Button,
    FormControl,
    InputGroup,
    FormGroup
} from 'react-bootstrap';

import './Facts.css';

class Facts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            facts: [],
            page: props.page,
            limit: 40,
            pageCount: 0,
            search: props.search,
            selected: props.selected - 1
        };
    }

    componentDidMount() {
        this.loadFactsFromServer();
    }

    deleteFact(fact) {
        var self = this;
        axios
            .delete(`${config.baseURL}/facts/${fact.id}`)
            .then(function(response) {
                self.loadFactsFromServer()();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadFactsFromServer() {
        var self = this;
        axios
            .get(`${config.baseURL}/facts`, {
                params: {
                    page: self.state.page,
                    limit: self.state.limit,
                    search: self.state.search
                }
            })
            .then(function(response) {
                self.setState({
                    facts: response.data.facts,
                    pageCount: response.data.pageCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handlePageClick = data => {
        let selected = data.selected + 1;

        const url = new URL(window.location.href);
        url.searchParams.set('page', selected);
        window.history.pushState(null, null, url); 

        this.setState({ page: selected, selected: data.selected }, () => {
            this.loadFactsFromServer();
        });
    };

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = event => {
        const { t } = this.props;

        const url = new URL(window.location.href);

        if(this.state.search) {
            url.searchParams.set('search', this.state.search);
        } else {
            url.searchParams.delete('search');

        }
        window.history.pushState(null, null, url); 

        event.preventDefault();
        this.loadFactsFromServer();
    };

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t(
            'Facts.title'
        )}`;

        return (
            <div className="Facts">
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('Facts.title')}
                                    <div className="btn-toolbar pull-right">
                                        <Link
                                            type="submit"
                                            className="btn btn-primary"
                                            to="/facts/facttypes"
                                        >
                                            <em className="fa fa-list fa-fw" />{' '}
                                            {t('Facts.fact_types')}
                                        </Link>
                                        <Link
                                            type="submit"
                                            className="btn btn-primary"
                                            to="/facts/create"
                                        >
                                            <em className="fa fa-plus fa-fw" />{' '}
                                            {t('Facts.add_fact')}
                                        </Link>
                                    </div>
                                </h1>

                                <ol className="breadcrumb">
                                    <li className="active">
                                        <i className="fa fa-info" />{' '}
                                        {t('Facts.title')}
                                    </li>
                                </ol>

                                <PaginationPanel
                                    heading={
                                        <Row>
                                            <Col xs={12} className="text-right">
                                                <form
                                                    role="search"
                                                    onSubmit={this.handleSubmit}
                                                >
                                                    <FormGroup controlId="search">
                                                        <InputGroup>
                                                            <FormControl
                                                                type="text"
                                                                value={
                                                                    this.state
                                                                        .search
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                                placeholder={t(
                                                                    'Search'
                                                                )}
                                                            />
                                                            <InputGroup.Button>
                                                                <Button
                                                                    onClick={
                                                                        this
                                                                            .handleSubmit
                                                                    }
                                                                >
                                                                    <i className="glyphicon glyphicon-search" />
                                                                </Button>
                                                            </InputGroup.Button>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </form>
                                            </Col>
                                        </Row>
                                    }
                                    pagination={
                                        <ReactPaginate
                                            previousLabel={t(
                                                'Pagination.previous'
                                            )}
                                            nextLabel={t('Pagination.next')}
                                            breakLabel={<Link to="#">...</Link>}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={3}
                                            pageRangeDisplayed={5}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={
                                                'pages pagination'
                                            }
                                            activeClassName={'active'}
                                            forcePage={this.state.selected}
                                        />
                                    }
                                >
                                    <FactTable
                                        facts={this.state.facts}
                                        onDelete={this.deleteFact.bind(this)}
                                    />
                                </PaginationPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}
export default translate('translations')(Facts);
